<div class="user-stats__table">
  <app-user-stats-table-header
    [ncells]="6"
    [start]="1"
    [icons]="['title_outline', 'first_access', 'last_access', 'clock', 'speed']"
    [labels]="[
      'user.stats.title',
      'user.stats.firstAccess',
      'user.stats.lastAccess',
      'user.stats.dedicatedHours',
      'user.stats.pagesHour'
    ]">
  </app-user-stats-table-header>

  <app-user-stats-table-row
    [nDataCells]="5"
    [formatIcon]="'format_ebook'"
    [formatLabel]="'formats.ebook'"
    [data]="[
      ebookStats.title,
      ebookStats.firstDate,
      ebookStats.lastDate,
      ebookStats.lastDedicatedHours,
      ebookStats.lastUnitsPerHour
    ]">
  </app-user-stats-table-row>

  <app-user-stats-table-row
    [nDataCells]="5"
    [formatIcon]="'format_audio'"
    [formatLabel]="'formats.audio'"
    [data]="[
      audioStats.title,
      audioStats.firstDate,
      audioStats.lastDate,
      audioStats.lastDedicatedHours,
      '--'
    ]">
  </app-user-stats-table-row>

  <app-user-stats-table-row
    [nDataCells]="5"
    [formatIcon]="'format_video'"
    [formatLabel]="'formats.video'"
    [data]="[
      videoStats.title,
      videoStats.firstDate,
      videoStats.lastDate,
      videoStats.lastDedicatedHours,
      '--'
    ]">
  </app-user-stats-table-row>

  <app-user-stats-table-row
    [nDataCells]="5"
    [formatIcon]="'format_education'"
    [formatLabel]="'formats.scorm'"
    [data]="[
      scormStats.title,
      scormStats.firstDate,
      scormStats.lastDate,
      scormStats.lastDedicatedHours,
      '--'
    ]">
  </app-user-stats-table-row>
</div>
